// 1. 기존 core 모듈
//import { NineUxUtil } from './ux/dialog/NineUxUtil.js';
import { nine, subscribeConfig, config } from './core/Config.js';
import { Trace, trace } from './core/Trace.js';
import { TaskDebouncer } from './core/TaskDebouncer.js';

// 2. 신규 net 및 ux 모듈 추가
import { api, Fetch } from './net/Fetch.js';
import { Loading } from './ux/Loading.js';

import { nineDialog } from './ux/dialog/nineDialog.js';
import { nineConfirmPopup, nineAlertPopup } from './ux/dialog/nineConfirm.js';
import { ninePromptPopup } from './ux/dialog/ninePrompt.js';

import { safe } from "./utils/promise.js"; // 경로에 맞춰 임포트
// ux
import './ux/nine-splitter.js';
import './ux/dialog/NineUxUtil.js';
import './utils/NineUtil.js';
import './utils/NinePopup.js';
import './ux/dialog/nine-simple-popup.js';

/**
const utilInstance = new NineUxUtil();
nine.alert = utilInstance.alert.bind(utilInstance);
nine.confirm = utilInstance.confirm.bind(utilInstance);
nine.prompt = utilInstance.prompt.bind(utilInstance);
nine.formatDate = utilInstance.formatDate.bind(utilInstance);
	*/
//const utilInstance = new NineUxUtil();

// 💡 이미 화살표 함수로 바인딩되어 있으므로, 객체 통째로 복사해주면 끝납니다!
//Object.assign(nine, utilInstance);

nine.safe = safe;

// 기존 nine 객체(Config)와 Util 기능을 합성
//Object.assign(nine, utilInstance);

nine.api = api;
nine.trace = trace;
nine.subscribeConfig = subscribeConfig;
nine.config = config || {};

export {
	nine,
	subscribeConfig,
	config,
	Trace,
	trace,
	TaskDebouncer,
	api,               // 🚀 추가: 이제 서비스에서 api.get() 가능
	Fetch,             // 🚀 추가: 클래스 자체도 혹시 모르니 노출
	Loading as loading, // 🚀 추가: loading.show() 로 쓰기 편하게 alias
	nineDialog,
	nineAlertPopup, nineConfirmPopup, ninePromptPopup
};

if (typeof window !== 'undefined') {
	window.nine = nine;
}
